var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.859 6.85l-10.98 11c-.1.1-.23.15-.359.15h-.03a.466.466 0 01-.35-.15l-4.99-5c-.2-.19-.2-.51 0-.7.189-.2.51-.2.698 0l4.661 4.67L19.15 6.15c.2-.2.51-.2.71 0 .189.19.189.51 0 .7z"
  })));
}
SvgTick.displayName = 'Tick';
export default SvgTick;